import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function EmailRecipientsRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.EmailRecipients', {
		url: '/emails/:id/recipients/:recipient_id',
		controllerAs: 'vm',
		controller: EmailRecipientsCtrl,
		templateUrl: '/ng/hub/Email/Recipients/EmailRecipientsCtrl.html?' + window.BUILD,
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Email/Recipients/EmailRecipientsCtrl.css'),
			recipient: ApiResourcify.endpoint('/emails/:id/recipients/:user_id'),
		},
	});
}

export class EmailRecipientsCtrl {
	constructor(recipient) {
		'ngInject';
		this.recipient = recipient;
	}
}
